import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Crown, Plus } from "lucide-react";
import { api } from "../lib/api";

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR") : "—");

export const ClubAdmin = () => {
  const [data, setData] = useState(null);
  const [newMember, setNewMember] = useState({ name: "", phone: "" });

  const load = () => api.get("/admin/club").then((r) => setData(r.data)).catch(console.error);
  useEffect(() => { load(); }, []);

  const extend = async (id) => {
    try { await api.post(`/admin/club/${id}/extend`); toast.success("Paiement 5,99€ enregistré — +30 jours"); load(); }
    catch { toast.error("Erreur"); }
  };
  const setStatus = async (id, status) => {
    try { await api.patch(`/admin/club/${id}`, { status }); toast.success(status === "cancelled" ? "Adhésion désactivée" : "Adhésion réactivée"); load(); }
    catch { toast.error("Erreur"); }
  };
  const add = async () => {
    try { await api.post("/admin/club", newMember); toast.success("Membre ajouté (30 jours)"); setNewMember({ name: "", phone: "" }); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };

  if (!data) return <p className="text-zinc-500">Chargement...</p>;
  const { stats, members } = data;

  return (
    <div data-testid="club-admin">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6">
        <div className="bg-ink-surface border border-neon-green/40 p-4"><div className="font-anton text-3xl text-neon-green" data-testid="club-stat-active">{stats.active}</div><div className="text-zinc-500 text-xs uppercase">Membres actifs</div></div>
        <div className="bg-ink-surface border border-yellow-400/40 p-4"><div className="font-anton text-3xl text-yellow-400">{stats.pending}</div><div className="text-zinc-500 text-xs uppercase">En attente (livraison)</div></div>
        <div className="bg-ink-surface border border-neon-magenta/40 p-4"><div className="font-anton text-3xl text-neon-magenta">{stats.mrr.toFixed(2)}€</div><div className="text-zinc-500 text-xs uppercase">Revenu mensuel TTC</div><div className="text-zinc-600 text-[10px]">soit {stats.mrr_ht?.toFixed(2)}€ HT (TVA 20% déduite)</div></div>
        <div className="bg-ink-surface border border-zinc-800 p-4"><div className="font-anton text-3xl text-white">{stats.total_revenue.toFixed(2)}€</div><div className="text-zinc-500 text-xs uppercase">Encaissé au total TTC</div><div className="text-zinc-600 text-[10px]">HT : {stats.total_revenue_ht?.toFixed(2)}€ · TVA : {stats.total_tva?.toFixed(2)}€</div></div>
      </div>

      <div className="flex flex-wrap gap-2 mb-6 items-center bg-ink-surface border border-zinc-800 p-4">
        <Crown className="h-5 w-5 text-neon-green" />
        <input data-testid="club-add-name" value={newMember.name} onChange={(e) => setNewMember({ ...newMember, name: e.target.value })} placeholder="Nom" className="bg-ink border border-zinc-700 text-white px-3 py-2 text-sm w-36" />
        <input data-testid="club-add-phone" value={newMember.phone} onChange={(e) => setNewMember({ ...newMember, phone: e.target.value })} placeholder="Téléphone" className="bg-ink border border-zinc-700 text-white px-3 py-2 text-sm w-40" />
        <button data-testid="club-add-btn" onClick={add} disabled={!newMember.phone.trim()} className="flex items-center gap-1 bg-neon-green text-black font-bold uppercase text-xs px-4 py-2 disabled:opacity-40"><Plus className="h-4 w-4" /> Ajouter (paiement reçu)</button>
      </div>

      {members.length === 0 ? <p className="text-zinc-500">Aucun membre pour le moment.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-zinc-500 uppercase text-xs border-b border-zinc-800">
              <th className="text-left py-2 pr-3">Client</th><th className="text-left py-2 pr-3">Téléphone</th>
              <th className="text-left py-2 pr-3">Statut</th><th className="text-left py-2 pr-3">Actif jusqu'au</th>
              <th className="text-left py-2 pr-3">Paiements</th><th className="text-right py-2">Actions</th>
            </tr></thead>
            <tbody>
              {members.map((m) => {
                const payments = m.payments || [];
                const paidTotal = payments.reduce((sum, p) => sum + (p.amount || 0), 0).toFixed(2);
                const last = payments[payments.length - 1];
                return (
                <tr key={m.id} data-testid="club-member-row" className="border-b border-zinc-900">
                  <td className="py-3 pr-3 text-white font-semibold">{m.name || "—"}</td>
                  <td className="py-3 pr-3 text-zinc-300">{m.phone}</td>
                  <td className="py-3 pr-3">
                    {m.is_active ? <span className="text-neon-green font-bold text-xs uppercase">● Actif</span>
                      : m.status === "pending" ? <span className="text-yellow-400 font-bold text-xs uppercase">⏳ En attente</span>
                      : m.status === "cancelled" ? <span className="text-red-400 font-bold text-xs uppercase">✕ Désactivé</span>
                      : <span className="text-zinc-500 font-bold text-xs uppercase">Expiré</span>}
                  </td>
                  <td className="py-3 pr-3 text-zinc-300">{fmtDate(m.paid_until)}</td>
                  <td className="py-3 pr-3 text-zinc-400 text-xs">
                    {payments.length} paiement{payments.length > 1 ? "s" : ""} · {paidTotal}€
                    {last && <div className="text-zinc-600">{fmtDate(last.date)} — {last.source}</div>}
                  </td>
                  <td className="py-3 text-right whitespace-nowrap">
                    <button data-testid="club-extend" onClick={() => extend(m.id)} className="text-neon-green border border-neon-green/40 px-2 py-1 text-xs uppercase font-bold hover:bg-neon-green hover:text-black transition-colors mr-2">+30j (5,99€)</button>
                    {m.status !== "cancelled"
                      ? <button data-testid="club-cancel" onClick={() => setStatus(m.id, "cancelled")} className="text-red-400 border border-red-500/40 px-2 py-1 text-xs uppercase font-bold hover:bg-red-500 hover:text-white transition-colors">Désactiver</button>
                      : <button data-testid="club-reactivate" onClick={() => setStatus(m.id, "active")} className="text-zinc-300 border border-zinc-600 px-2 py-1 text-xs uppercase font-bold hover:bg-zinc-700 transition-colors">Réactiver</button>}
                  </td>
                </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
